import * as React from 'react'
import { Grid, Col, Row } from 'react-bootstrap';
import  Register  from "../../components/Login/Register"


export const RegisterInner = (props: any) =>
    <div>
        <Grid bsClass="container">
            <Row>
                <Col xs={12} md={12}>
                    <Register/>
                </Col>
            </Row>
        
        </Grid>
    </div>


// WEBPACK FOOTER //
// ./src/Routes/Register/RegisterInner.tsx